import React from "react";
import profilePic from "../assets/profile.jpg";
function Hero() {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h1>Anshu Raj</h1>
        <p className="tagline">
          Full Stack Developer | Android Developer | Mechanical Engineer | IoT Enthusiast
        </p>

        {/* Skills tags */}
        <div className="hero-skills">
          <span className="skill-tag">Java</span>
          <span className="skill-tag">React</span>
          <span className="skill-tag">Firebase</span>
          <span className="skill-tag">Unity</span>
          <span className="skill-tag">API Development</span>
        </div>

        {/* Call to Action Buttons */}
        <div className="hero-buttons">
          <a href="#projects" className="cta-button">Explore My Work</a>
          <a
            href="/resume.pdf"
            className="cta-button cta-secondary"
            target="_blank"
            rel="noopener noreferrer"
          >
            Download Resume
          </a>
        </div>

        {/* Social Icons using FontAwesome Icon Components */}
        <div className="social-icons">
  <a href="https://github.com/MrAnshuRaj" target="_blank" rel="noopener noreferrer" aria-label="GitHub">
    <i className="fab fa-github fa-2x"></i>
  </a>
  <a href="https://linkedin.com/in/anshu-raj-142b55253" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
    <i className="fab fa-linkedin fa-2x"></i>
  </a>
  <a href="mailto:anshurajwork@gmail.com" aria-label="Email">
    <i className="fas fa-envelope fa-2x"></i>
  </a>
</div>

      </div>

      {/* Optional Profile Image */}
      <div className="hero-image">
        <img src={profilePic} alt="Anshu Raj Profile" />
      </div>
    </section>
  );
}

export default Hero;
